// Load jQuery
import $ from 'jquery';
window.$ = window.jQuery = $;

jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

//Load Modules
import './modules/animation';
import './modules/accordion';
import './modules/bannerVideo';
// import './modules/formInputs';
// import './modules/gravityForms';
import './modules/menu';
import './modules/tabs';
import './modules/videoInline';
// import './modules/sliders';
import './modules/sliders';
import './modules/signpostsControl';
// import './modules/videoButtonReplacer';
// import './modules/videoPopup';
// import './modules/videoPlay';
